export default __webpack_public_path__ + "static/media/success.50d9d0f7.svg";